
import React, {useEffect, useState} from 'react';
import "./MonthlyPosts.css";
import { useGlobalContext } from "../../context";
import { getAllClients } from "../../api";
import chunk from "chunk";
import Pagination from "../../Components/Pagination/Pagination";
import PostsPopup from "./PostsPopup";

function MonthlyPosts() {

    const {
        allUsers, setAllUsers,
        showUsers, setShowUsers,
        chunkData, setChunkData,
        tableData, setTableData,
        setOpenMonthlyPotst
    } = useGlobalContext()

    const [checkinClient, setCheckinClient] = useState();
    const [filterValue, setFilterValue] = useState("");

    const getAllClientsData = async () => {
        const data = await getAllClients();
        if (data) {
            setAllUsers(data.data);
        }
    }

    useEffect(() => {
        getAllClientsData();
    },[])

    useEffect(() => {
        const usersData = allUsers.map(item => { return { ...item, active: false } });
        setShowUsers(usersData);
    },[allUsers])

    useEffect(() => {
        setChunkData(chunk(showUsers,100));
        const activeClients = showUsers.find(item => item.active === true);
        setCheckinClient(activeClients);
    }, [showUsers])

    const dateUpdate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        })
    }

    const checkUser = (user) => {
        setShowUsers(allClients => allClients.map(item => item.id === user.id ? { ...item, active: !item.active } : { ...item, active: false }));
    }

    const openPostPopup = () => {
        if(checkinClient) setOpenMonthlyPotst(true)
    }

    const filterClients = () => {
        if (filterValue) {
            const filterData = showUsers.filter(item => item.fullName.toLowerCase().includes(filterValue.toLowerCase()) || item.facebookProfileId.includes(filterValue));
            setShowUsers(filterData);
        }
    }

    const clearFilterData = () => {
        const usersData = allUsers.map(item => { return { ...item, active: false } });
        setShowUsers(usersData);
        setFilterValue("")
    }

    return (
        <div className="Schedule">
            <div
                className="usersTableHeaderBox"
                style={{
                    width: "100%",
                    padding: "0 20px 0 10px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "2px solid lightgray",
                }}
            >
                <h3 className="usersTableHeaderText">
                    MONTHLY POSTS
                </h3>
                <span className="monthlyPostFilterBox">
                    <input
                        type="text"
                        value={filterValue}
                        onChange={(e) => setFilterValue(e.target.value)}
                        placeholder="Name or Facebook ID"
                    />
                    <button
                        className="monthlyPostFilterBtn"
                        onClick={filterClients}
                    >
                        Filter
                    </button>
                    <button
                        className="monthlyPostFilterBtn filterClearBtn"
                        onClick={clearFilterData}
                    >
                        Clear
                    </button>
                </span>
                <span className="monthlyPostsHeaderBtnsBox">
                    <button
                        className="createTemplateButton"
                        style={{
                            cursor: checkinClient ? "pointer" : "not-allowed"
                        }}
                        onClick={openPostPopup}
                    >
                        Create Post
                    </button>
                </span>
            </div>
            <div className="scheduleMainBox monthlyMainBox">
                <div className="AddPostTableRowBox">
                    <span className="addPostClientID addPostHeaderText">ID</span>
                    <span className="addPostCheckBox addPostHeaderText"></span>
                    <span className="addPostFullName addPostHeaderText">FULL NAME</span>
                    <span className="addPostProfileType addPostHeaderText">PROFILE TYPE</span>
                    <span className="addPostFbID addPostHeaderText">FACEBOOK ID</span>
                    <span className="addPostInstaId addPostHeaderText">INSTAGRAM ID</span>
                    <span className="addPostCategory addPostHeaderText">CATEGORY</span>
                    <span className="addPostDate addPostHeaderText">DATE CREATED</span>
                </div>
                {
                    tableData && tableData.map((item, index) =>
                        <div
                            className="AddPostTableRowBox"
                            key={item.id}
                        >
                            <span className="addPostClientID">{index + 1}</span>
                            <span className="addPostCheckBox">
                                 <label className="checkboxLabel">
                                     <input
                                         type='checkbox'
                                         onChange={checkUser.bind(this, item)}
                                         checked={item.active}
                                     />
                                    <span></span>
                                </label>
                            </span>
                            <span className="addPostFullName">{item.fullName}</span>
                            <span
                                className="addPostProfileType">{item.subscription.replaceAll("_", " and ").toLowerCase()}</span>
                            <span className="addPostFbID">{item.facebookProfileId}</span>
                            <span
                                className="addPostInstaId">{item.instagramProfileId ? item.instagramProfileId : "-"}</span>
                            <span className="addPostCategory">{item.category.replaceAll("_", " ").toLowerCase()}</span>
                            <span className="addPostDate">{dateUpdate(item.creationDate)}</span>
                        </div>
                    )
                }
            </div>
            <Pagination
                chunkData={chunkData}
                setTableData={setTableData}
            />
            <PostsPopup
                checkinClient={checkinClient}
                setShowUsers={setShowUsers}
            />
        </div>
    )
}

export default MonthlyPosts